module.exports = __webpack_public_path__ + "media/images/countryrect/cf-1165e2bbb1e824abcd448f45f728fa90.svg";